import getStore from '../store';
import { mutator } from 'satcheljs';
import { setFetchingFullItem } from '../actions/searchResultStoreActions';

/**
 * Set the flag that a full calendar item is being fetched.
 */
export let setFetchingFullItemMutator = mutator(setFetchingFullItem, item => {
    let store = getStore();
    store.fetchingFullItem = item.setFetchingFullItem;
});
